import { PropsWithChildren } from "react";
import { Auth0Provider, type AppState } from "@auth0/auth0-react";
import { useNavigate } from "react-router";

export function Auth0ProviderWithNavigate({ children }: PropsWithChildren) {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      onRedirectCallback={(appState?: AppState) => {
        navigate(appState?.returnTo || window.location.pathname);
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        scope: "admin email profile",
      }}
    >
      {children}
    </Auth0Provider>
  );
}
